import { FC, useState } from "react";
import { Modal } from "@monolith-forensics/monolith-ui";

import CreateValidationForm from "../Forms/CreateValidationForm";

const MODAL_WIDTH = 550;

interface CreateValidationModalProps {
  show: boolean;
  assetUuid: string;
  onClose: () => void;
}

export const CreateValidationModal: FC<CreateValidationModalProps> = ({
  show,
  assetUuid,
  onClose,
}) => {
  const [submitting, setSubmitting] = useState(false);

  // User-initiated close (Cancel; the mfui Modal has no overlay/Esc dismiss
  // and its close button isn't enabled here). Guarded because closing
  // mid-request would still create the row and leave uploads in flight.
  const handleClose = () => {
    if (submitting) return;
    onClose();
  };

  // Success path. Deliberately unguarded: the form's submitting flag is
  // still true here (it clears in the form's finally), so routing through
  // handleClose would only work by reading a stale closure. No callback to
  // the host: useCreateAssetValidation's invalidation refreshes the table.
  const handleSubmit = () => {
    onClose();
  };

  return (
    <Modal open={show} onClose={handleClose}>
      <Modal.Title>Add Validation</Modal.Title>
      <Modal.SubTitle style={{ marginBottom: 15 }}>
        Record a validation for this asset and attach its documentation.
      </Modal.SubTitle>
      <CreateValidationForm
        width={MODAL_WIDTH}
        assetUuid={assetUuid}
        onSubmit={handleSubmit}
        onCancel={handleClose}
        onSubmittingChange={setSubmitting}
      />
    </Modal>
  );
};
